import _useRouter from "./_useRouter";
export default _useRouter;
